import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  printAllOperationDirectionsOnClick: () => void;
  printPickingListOnClick: () => void;
  downloadPlanCsvPerPacketOnClick: () => void;
  downloadPlanCsvPerPlaceOnClick: () => void;
  // V2用のボタン（比較用）
  downloadPlanCsvPerPacketV2OnClick: () => void;
  downloadPlanCsvPerPlaceV2OnClick: () => void;
}

const SelectPrintPresenter: FC<Props> = memo((
  {
    printAllOperationDirectionsOnClick,
    printPickingListOnClick,
    downloadPlanCsvPerPacketOnClick,
    downloadPlanCsvPerPlaceOnClick,
    downloadPlanCsvPerPacketV2OnClick,
    downloadPlanCsvPerPlaceV2OnClick
  }
) => (
  <Stack p={2} spacing={1}>
    <Stack>
      <Typography>
        出力形式を選択してください
      </Typography>
    </Stack>
    <Stack divider={<Divider />} spacing={1}>
      <Stack>
        <Button
          onClick={printAllOperationDirectionsOnClick}
          startIcon={<ExploreRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          配送指示書
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={printPickingListOnClick}
          startIcon={<ListAltRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          ピッキングリスト
        </Button>
      </Stack>
      <Stack spacing={1}>
        <Typography variant="subtitle2" color="text.secondary">
          V3（ShipmentOrder形式）
        </Typography>
        <Button
          onClick={downloadPlanCsvPerPacketOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車CSVダウンロード(商品毎)
        </Button>
        <Button
          onClick={downloadPlanCsvPerPlaceOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車XLSXダウンロード(地点毎)
        </Button>
      </Stack>
      <Stack spacing={1}>
        <Typography variant="subtitle2" color="text.secondary">
          V2（Order形式 - 比較用）
        </Typography>
        <Button
          onClick={downloadPlanCsvPerPacketV2OnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車CSVダウンロード(商品毎) V2
        </Button>
        <Button
          onClick={downloadPlanCsvPerPlaceV2OnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車XLSXダウンロード(地点毎) V2
        </Button>
      </Stack>
    </Stack>
  </Stack>
  ));

export default SelectPrintPresenter;
